/* Prime Organics | sitewide header pill + nav sheet.
   Ported from Meditonic's mt-header. Two PO-specific jobs on top of it:
   the pill stands down where the sw-stickybar is already the page header, and
   the sheet measures whichever pill IS the header so it never opens underneath it. */
(function () {
  var d = document;

  function boot(head) {
    if (head.poBooted) return;
    head.poBooted = true;

    var burger = head.querySelector('[data-po-menu]');
    var panel = d.getElementById(head.dataset.poPanel || 'po-nav-panel');
    var cartBtn = head.querySelector('[data-po-cart]');
    var countEl = head.querySelector('[data-po-cart-count]');
    var spacer = d.querySelector('.po-head-spacer');

    /* ---- stand down on the sw product templates ----
       There the sw-stickybar is the page header. The CSS :has() rule already
       hides us before first paint; this repeats it for browsers without :has()
       and, crucially, leaves the sheet fully wired — the stickybar burger
       resolves to [data-po-menu] and clicks it even while the pill is hidden. */
    var pinnedBar = d.querySelector('[data-sw-pinned="true"]');
    if (pinnedBar) {
      head.classList.add('is-yielded');
      if (spacer) spacer.classList.add('is-yielded');
    }

    /* ---- scrolled state + offset under any bar still on screen ---- */
    var ticking = false;
    function topBar() {
      /* an in-flow bar above the header, e.g. the sw welcome-offer countdown */
      return d.querySelector('[data-sw-annc]') || d.querySelector('.po-header__strip');
    }
    function paint() {
      head.classList.toggle('is-scrolled', window.scrollY > 8);
      var bar = topBar();
      var h = bar ? bar.offsetHeight : 0;
      head.style.setProperty('--poh-top', Math.max(0, h - window.scrollY) + 'px');
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { paint(); measureSheet(); ticking = false; });
    }, { passive: true });
    window.addEventListener('resize', function () { paint(); measureSheet(); });
    paint();

    /* ---- how far down the sheet has to start ----
       Read off the live header rather than assumed from tokens: on a product
       page that is the sw-stickybar pill, on every other template it is ours,
       and on a page with the countdown bar both sit lower than they look. */
    function measureSheet() {
      if (!panel) return;
      var ref = pinnedBar
        ? (pinnedBar.querySelector('.sw-stickybar__pill') || pinnedBar)
        : head.querySelector('.po-head__pill');
      if (!ref) return;
      var b = ref.getBoundingClientRect().bottom;
      if (b > 0) panel.style.setProperty('--poh-sheet-top', Math.round(b) + 'px');
    }
    measureSheet();
    window.addEventListener('load', measureSheet);

    /* ---- the sheet ---- */
    if (burger && panel) {
      var items = panel.querySelectorAll('.po-nav__link, .po-nav__feature, .po-nav__foot');
      for (var i = 0; i < items.length; i++) {
        items[i].style.setProperty('--poh-d', (0.06 + i * 0.045).toFixed(3) + 's');
      }

      var open = function () {
        measureSheet();
        panel.classList.add('is-open');
        burger.setAttribute('aria-expanded', 'true');
        d.body.classList.add('po-nav-open');
        var sheet = panel.querySelector('.po-nav__sheet');
        if (sheet) setTimeout(function () { sheet.focus(); }, 180);
      };
      var close = function (focusBack) {
        panel.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
        d.body.classList.remove('po-nav-open');
        /* only pull focus back to a button the shopper can actually see */
        if (focusBack && !head.classList.contains('is-yielded')) burger.focus();
      };

      burger.addEventListener('click', function () {
        panel.classList.contains('is-open') ? close(false) : open();
      });
      var scrim = panel.querySelector('[data-po-close]');
      if (scrim) scrim.addEventListener('click', function () { close(false); });
      d.addEventListener('keydown', function (e) {
        if ((e.key === 'Escape' || e.keyCode === 27) && panel.classList.contains('is-open')) close(true);
      });
      panel.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab' && e.keyCode !== 9) return;
        var f = panel.querySelectorAll('a[href], button:not([disabled])');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
      });
      /* a link navigates, so let the sheet shut behind it. An in-page anchor
         does not navigate at all, which would otherwise leave it hanging open. */
      panel.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('a[href]')) close(false);
      });
    }

    /* ---- cart count ---- */
    var last = null;
    function setCount(n) {
      if (!countEl) return;
      countEl.textContent = n;
      if (last !== null && n !== last && cartBtn) {
        cartBtn.classList.remove('is-bumped');
        void cartBtn.offsetWidth;
        cartBtn.classList.add('is-bumped');
      }
      last = n;
    }
    function refresh() {
      fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) { setCount(c.item_count); })
        .catch(function () {});
    }
    refresh();
    /* pocd:changed is what po-cart-drawer.js fires after every write */
    d.addEventListener('pocd:changed', function () { setTimeout(refresh, 120); });
    d.addEventListener('cart-drawer:refresh', function () { setTimeout(refresh, 400); });
    d.addEventListener('sw:cart-added', function () { setTimeout(refresh, 300); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  }

  function run() {
    d.querySelectorAll('[data-po-head]').forEach(function (el) {
      try { boot(el); } catch (e) { if (window.console) console.warn('po-head:', e); }
    });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', run); else run();
  d.addEventListener('shopify:section:load', run);
})();
